import styles from './VerticalHeaderImageCard.module.scss';

const VerticalHeaderImageCard = ({element}) => {
    const { vertPhoto } = element
    return (  
        <div className= {styles.container}>
            <img className={styles.photo} src={vertPhoto} alt='фотограф Ставрополь'/>
        </div> 
    );
}
 
export default VerticalHeaderImageCard;